const normalizeBaseUrl = (url) => {
  const value = String(url || '').trim();
  if (!value) return 'https://analytics.shift-ev.com/';
  return value.endsWith('/') ? value : `${value}/`;
};

export const BASE_URL = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL || 'https://analytics.shift-ev.com/');
